// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-block__pre-heading[data-v-2198bff4]{display:flex}p[data-v-2198bff4]{text-align:center}.body-2[data-v-2198bff4]{font-size:12px!important;font-weight:500}.w-block__pre-heading--mobile .container .layout .flex[data-v-2198bff4]{display:flex;justify-content:center}", ""]);
// Exports
module.exports = exports;
